import { APIWorkspaceAttributes } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import { resetGraph } from 'modelInterface/graphModelActions';
import { loadLucidState } from './actions';
import {
  addWorkspaces,
  markWorkspaceAggregatedLoaded,
} from 'streams/workspaces/actions';

export const loadWorkspaces = (workspaces: APIWorkspaceAttributes[] = []) => {
  workspaces.filter(Boolean).forEach(workspaceData => {
    dispatchAction(
      markWorkspaceAggregatedLoaded({ workspaceId: workspaceData._id })
    );
    dispatchAction(resetGraph());
  });
  dispatchAction(addWorkspaces({ workspaces, silent: true }));
};

export const loadLucidSlides = () => {
  dispatchAction(loadLucidState());
};
